class TemplateEditorUtils {
    static checkMouseUpHasSelection(event, elementType) {
        //checks if someone has started hightlighting text
        //but release mouse on another element
        const selection = window.getSelection().toString()
        if (selection.length > 0) {
            event.stopPropagation()
            event.preventDefault()
            return false
        }
        return true
    }
}

export default TemplateEditorUtils
